import { ENGLISH_NUMERALS, PERSIAN_NUMERALS } from '../constants/numbers'

export function convertPersianToEnglish(input: string) {
  return input.replace(/\d/g, (digit) => PERSIAN_NUMERALS[Number(digit)])
}

export function toEnglishDigits(input: string): string {
  return input.replace(
    new RegExp(`[${PERSIAN_NUMERALS.join('')}]`, 'g'),
    (digit) => ENGLISH_NUMERALS[PERSIAN_NUMERALS.indexOf(digit)]
  )
}
